/**
 * Een kleine lijn zonder assen (Bronnen: berichten per uur, 24 uur): het verloop, niet het getal; dat staat ernaast.
 * Valt de lijn aan het eind naar nul, dan is het laatste stuk in de kleur van een waarschuwing.
 */
export default function Sparkline({ punten, breed = 160, hoog = 32, label }) {
  const max = Math.max(1, ...punten.map((p) => p.n));
  const x = (i) => 1 + (punten.length < 2 ? 0 : (i / (punten.length - 1)) * (breed - 2));
  const y = (v) => hoog - 2 - (v / max) * (hoog - 4);
  const lijn = punten.map((p, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(p.n).toFixed(1)}`).join('');
  const stil = punten.length > 1 && punten.at(-1).n === 0 && punten.some((p) => p.n > 0);
  return (
    <svg className="sparkline" width={breed} height={hoog} viewBox={`0 0 ${breed} ${hoog}`} role="img" aria-label={label}>
      <path d={`${lijn}L${x(punten.length - 1)},${hoog}L${x(0)},${hoog}Z`} fill="var(--cyan-ink)" opacity="0.1" />
      <path d={lijn} fill="none" stroke="var(--cyan-ink)" strokeWidth="1.5" strokeLinejoin="round" />
      {stil && <circle cx={x(punten.length - 1)} cy={y(0)} r="3" fill="var(--st-warning)" />}
    </svg>
  );
}
